export default __webpack_public_path__ + "static/media/delete.9137dae7.svg";